import { PhoneDeliveryChannels } from '../../../types';

export enum PhoneDeliveryChannel {
  WhatsApp = 'whatsApp',
  SMS = 'sms',
}

export const hasSelectedPhoneChannel = (
  channels: PhoneDeliveryChannels = {},
): boolean =>
  Boolean(
    channels[PhoneDeliveryChannel.WhatsApp] || channels[PhoneDeliveryChannel.SMS],
  );
